export function isRestricted(event, currentUserUuid) {
  return !(!event.classification || event.classification === 'NONE' || event.accessControl?.includes(currentUserUuid));
}
